import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import { useSwiftDestinationForm } from "./SwiftDestination.form";

import type { SwiftDestinationFormType } from "./SwiftDestination.form";
import type { UseFormReturn } from "react-hook-form";

type SwiftDestinationFormReturnType = UseFormReturn<SwiftDestinationFormType>;

const SwiftDestinationContext = createContext<SwiftDestinationFormReturnType>(
  {} as SwiftDestinationFormReturnType,
);
export const useSwiftDestinationContext = () =>
  useContext(SwiftDestinationContext);

export const SwiftDestinationFormProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const swiftDestinationForm = useSwiftDestinationForm();
  return (
    <SwiftDestinationContext.Provider value={{ ...swiftDestinationForm }}>
      {children}
    </SwiftDestinationContext.Provider>
  );
};
